module.exports = __webpack_public_path__ + "static/media/gold_vip_bg.cac40980.svg";